import React from 'react'

const WorkOrderManagement = () => {
  return <p>TODO</p>
}

export default WorkOrderManagement
